import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const closeIcon: SvgIconData = {
  viewBox: '10.06 10.06 79.05 79.05',
  element: (
    <path d="M82 87.88a4.17 4.17 0 0 0 5.9-5.9l-32.42-32.4 32.4-32.4a4.16 4.16 0 1 0-5.89-5.9l-32.4 32.4-32.41-32.4a4.17 4.17 0 0 0-5.9 5.9l32.41 32.4-32.4 32.41a4.16 4.16 0 1 0 5.88 5.9L49.6 55.46z" />
  ),
};
